// extracted by mini-css-extract-plugin
export var addToCartButton = "_o3-b";
export var arrowButtonContainer = "_o3-9";
export var arrowButtonIcon = "_o3-a";
export var carouselArrowButton = "_o3-6";
export var carouselElementContainer = "_o3-1";
export var left = "_o3-7";
export var productDisplayCarouselContainer = "_o3-0";
export var productTileContainer = "_o3-2";
export var productTileImage = "_o3-4";
export var productTileImageContainer = "_o3-3";
export var productTileTitle = "_o3-5";
export var right = "_o3-8";
export var sliderOverflow = "_o3-c";